var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "reader" },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("span", { staticClass: "text-h5" }, [_vm._v("Entity Tags")])
          ]),
          _c("v-col", [
            _c(
              "div",
              { staticClass: "d-flex justify-center justify-md-end mb-2" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      to: { name: "newTag" },
                      title: "Create a new tag",
                      color: "success"
                    }
                  },
                  [
                    _c("v-icon", { staticClass: "mr-2" }, [_vm._v("mdi-plus")]),
                    _vm._v("New")
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.tags,
          "items-per-page": 15,
          dense: "",
          "footer-props": {
            showFirstLastPage: true,
            itemsPerPageOptions: [-1, 10, 15, 20, 25],
            firstIcon: "mdi-arrow-collapse-left",
            lastIcon: "mdi-arrow-collapse-right",
            prevIcon: "mdi-minus",
            nextIcon: "mdi-plus"
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.text`,
              fn: function({ item }) {
                return [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { name: "editTag", params: { id: item.id } },
                        title: item.text
                      }
                    },
                    [_vm._v(" " + _vm._s(item.text) + " ")]
                  )
                ]
              }
            },
            {
              key: `item.entityTypes`,
              fn: function({ item }) {
                return [_vm._v(" " + _vm._s(item.entityTypes.join(", ")) + " ")]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }